









import './LoadingDataSpinner.scss'
import { defineComponent, ref, toRef, watch } from '@vue/composition-api'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'

export default defineComponent({
  name: 'LoadingDataSpinner',
  components: {
    'clip-loader': ClipLoader
  },
  props: {
    label: {
      type: String,
      required: false,
      default: 'Data'
    },
    data: {
      type: [Array, Object],
      required: true
    }
  },
  setup (props) {
    const showLoadingData = ref(true)
    const dataRef = toRef(props, 'data')
    watch(dataRef, () => showLoadingData.value = false)

    return {
      showLoadingData
    }
  }
})
